import React from "react";

// Logotipo oficial da marca extraído do banner — bolsa com globo.
// Mostra sempre a logo idêntica em todo o site.
const BrandMark = ({
    size = 40,
    bgClass = "bg-brand-ink",
    rounded = "rounded-sm",
    className = "",
    onlyImage = false,
}) => {
    const img = (
        <img
            src="/logo.png"
            alt="Vitrine Deus Proverá"
            data-testid="brand-logo-img"
            className="object-contain"
            style={{ width: "78%", height: "78%" }}
            draggable={false}
        />
    );
    if (onlyImage) {
        return (
            <img
                src="/logo.png"
                alt="Vitrine Deus Proverá"
                data-testid="brand-logo-img"
                className={`object-contain ${className}`}
                style={{ width: size, height: size }}
                draggable={false}
            />
        );
    }
    return (
        <div
            data-testid="brand-mark"
            className={`inline-flex items-center justify-center overflow-hidden ${bgClass} ${rounded} ${className}`}
            style={{ width: size, height: size }}
            aria-label="Vitrine Deus Proverá"
        >
            {img}
        </div>
    );
};

export default BrandMark;
